import { useEffect, useState } from 'react';
import ClientListTable from './ClientListTable';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useAppSelector } from '../../Reducers/store';
import ClientApi from '../../Api/ClientApi';
import { Client } from '../../Models/Client';

export default function ClientList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [clientListData, setClientListData] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getClients();
  }, [userModel]);

  const getClients = () => {
    if (userModel) {
      try {
        setIsLoading(true);
        return ClientApi.getClientsList()
          .then((res) => {
            setClientListData(res.data);

            setIsLoading(false);
          })
          .catch((err) => {
            toast.error('Error');
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error('Error');
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className='w-full'>
        <div className='w-full h-[74px] p-4'>
          <div className='mx-1 flex items-end'>
            <div className='flex flex-1'>
              <h1 className='text-gray-900 font-bold text-4xl'>
                <div>Client List</div>
              </h1>
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className='w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto'>
            <ClientListTable data={clientListData} />
          </div>
        </div>
      </div>
    </>
  );
}
